import React, { useState } from "react";
import {  Link } from "react-router-dom";
import { useLoginSellerMutation } from "../redux/apislice";
import "toastr/build/toastr.min.css";
import { toast } from "react-hot-toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import setting from '../base.json'
const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [loginSeller, { isLoading }] = useLoginSellerMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await loginSeller({ email, password }).unwrap();

      if (response?.accessToken && response?.refreshToken) {
        const expiresIn = 1000 * 60 * 60 * 24 * 7;

        const tokenData = {
          value: response?.refreshToken,
          expiry: new Date().getTime() + expiresIn,
        };
        localStorage.setItem("refreshToken", JSON.stringify(tokenData));
        // navigate('/')
        window.location.href = setting.url||"https://seller.khushhali.com";
        return;
      }
      toast.success(response?.message);


      // login(response?.token);
    } catch (error) {
      console.error("Login failed:", error.status);

      const errorMessage =
        error?.data?.message ||
        error?.error ||
        error?.message ||
        "Login failed. Please try again.";

      toast.error(errorMessage);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center font-sans relative overflow-hidden bg-gradient-to-b from-sky-300 via-sky-100 to-white">
      <div className="absolute w-[400px] h-[400px] bg-white rounded-full blur-[120px] opacity-40 top-[-50px] left-[100px] z-0" />
      <div className="absolute w-[300px] h-[300px] bg-white rounded-full blur-[100px] opacity-50 bottom-[50px] right-[100px] z-0" />
      <div className="absolute w-[350px] h-[350px] bg-white rounded-full blur-[90px] opacity-30 bottom-[100px] left-[50px] z-0" />

      <div className="z-10 bg-white shadow-xl rounded-xl w-full max-w-5xl grid md:grid-cols-2 overflow-hidden">
        <div className="relative bg-[#f3f4f6] p-10 flex flex-col justify-center items-center border-r border-gray-200">
          <div className="absolute top-0 left-0 w-full h-10 bg-gradient-to-b from-gray-300/20 to-transparent z-10 pointer-events-none rounded-l-xl" />

          <h1 className="text-3xl text-center font-bold text-gray-800 mb-3 z-20">
            Welcome to Khushhalli Seller Pannel
          </h1>
          <p className="text-gray-600 text-sm text-center z-20">
            Buy Bold. Sell Smart. Grow Together.

          </p>
        </div>

        <div className="relative p-10">
          <div className="absolute top-0 left-0 w-full h-10 bg-gradient-to-b from-gray-300/20 to-transparent z-10 pointer-events-none rounded-r-xl" />

          <h2 className="text-2xl font-bold text-gray-800 text-center mb-2 z-20">
            Login to Your Account
          </h2>
          <p className="text-sm text-gray-500 text-center mb-6 z-20">
            Enter your email and password to access your dashboard
          </p>

          <form onSubmit={handleSubmit} className="space-y-5 z-20 relative">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              />
            </div>

            <div className="relative">
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Password
              </label>
              <div className="relative">
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  placeholder="••••••••"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 pr-10"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 hover:text-gray-700"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <div className="text-right mt-1">
                <a href="/forgot-password" className="text-blue-600 hover:underline text-sm">
                  Forgot Password?
                </a>
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className={`w-full py-2 px-4 bg-indigo-600 text-white rounded-lg font-semibold hover:bg-indigo-700 transition flex items-center justify-center ${isLoading ? "opacity-80 cursor-not-allowed" : ""
                }`}
            >
              {isLoading ? (
                <>
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Signing In...
                </>
              ) : (
                "Sign In"
              )}
            </button>
          </form>

          <p className="text-sm text-gray-500 text-center mt-6 z-20">
            Don't have an account?{" "}
            <Link
              to="/register"
              className="text-indigo-600 font-medium hover:underline"
            >
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;